import { __awaiter, __generator } from "tslib";
var defaultOption = {
    timeout: 60000,
};
export default function snsLogin(_a) {
    var _b = (_a === void 0 ? defaultOption : _a).timeout, timeout = _b === void 0 ? 60000 : _b;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2, import("@bilibili/sns-login").then(function (_a) {
                    var snsVerify = _a.snsVerify;
                    return new Promise(function (resolve, reject) {
                        snsVerify().then(function (fastRegister) {
                            var wrapperCb = function () {
                                resolve();
                                fastRegister.removeEventListener("login-success", wrapperCb);
                            };
                            fastRegister.addEventListener("login-success", wrapperCb);
                            var cancelCb = function () {
                                var rej = {
                                    reason: "cancel",
                                };
                                reject(rej);
                                fastRegister.removeEventListener("login-cancel", cancelCb);
                            };
                            fastRegister.addEventListener("login-cancel", cancelCb);
                            setTimeout(function () {
                                fastRegister.hideComponent();
                                var rej = {
                                    reason: "timeout",
                                };
                                reject(rej);
                                fastRegister.removeEventListener("login-success", wrapperCb);
                                fastRegister.removeEventListener("login-cancel", cancelCb);
                            }, timeout);
                            fastRegister.showComponent();
                        });
                    });
                })];
        });
    });
}
//# sourceMappingURL=snsLogin.js.map